import { useI18n } from "@/lib/i18n";
import type { Lang } from "@/lib/translations";
import { Languages } from "lucide-react";

export function LanguageToggle() {
  const { lang, setLang, t } = useI18n();
  const next: Lang = lang === "de" ? "en" : "de";
  return (
    <button
      onClick={() => setLang(next)}
      aria-label={`${t.common.languageLabel}: ${lang === "de" ? "EN" : "DE"}`}
      className="inline-flex h-9 items-center gap-1.5 rounded-full border border-border bg-card px-3 text-xs font-semibold uppercase text-foreground transition-all hover:scale-105 hover:border-indigo/50"
    >
      <Languages className="h-3.5 w-3.5" />
      {lang === "de" ? "EN" : "DE"}
    </button>
  );
}
